export let XMLRootTag =  "MIP";

export function setXMLRootTag(val) {
  XMLRootTag = val;
}